(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-trust"] && !Shopify.designMode) return;
  try {
    
  class BrandTrustCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-brand-trust-track]');
      this.slides = [...root.querySelectorAll('[data-brand-trust-slide]')];
      this.previousButton = root.querySelector('[data-brand-trust-previous]');
      this.nextButton = root.querySelector('[data-brand-trust-next]');

      if (!this.track || !this.previousButton || !this.nextButton || this.root.dataset.carouselReady === 'true') return;

      this.root.dataset.carouselReady = 'true';
      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.track);
      this.updateButtons();
    }

    move(direction) {
      const slide = this.slides[0];
      if (!slide) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * (slide.getBoundingClientRect().width + gap),
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    }

    updateButtons() {
      const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
      this.previousButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;
    }
  }

  const initializeBrandTrustCarousels = (scope = document) => {
    scope.querySelectorAll('[data-brand-trust-carousel]').forEach((root) => new BrandTrustCarousel(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeBrandTrustCarousels());
  } else {
    initializeBrandTrustCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => initializeBrandTrustCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choosz-reviews"] && !Shopify.designMode) return;
  try {
    
  class ChooszReviewsCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-choosz-reviews-viewport]');
      this.track = root.querySelector('[data-choosz-reviews-track]');
      this.originalSlides = [...root.querySelectorAll('[data-choosz-review-slide]')];
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = root.dataset.autoplay === 'true' && !this.reducedMotion;
      this.intervalDuration = Number(root.dataset.interval) || 6000;
      this.cloneCount = Math.min(3, this.originalSlides.length);
      this.index = this.cloneCount;
      this.timer = null;
      this.transitionFallbackTimer = null;
      this.resizeObserver = null;
      this.isAnimating = false;
      this.pointerId = null;
      this.pointerStartX = null;
      this.pointerOffsetX = 0;
      this.isDragging = false;

      if (!this.viewport || !this.track || this.originalSlides.length < 2) return;

      this.addClones();
      this.bindEvents();
      this.observeSlideHeights();
      this.setPosition(false);
      this.updateViewportHeight();
      document.fonts?.ready.then(() => this.updateViewportHeight());

      this.startAutoplay();
    }

    addClones() {
      const before = this.originalSlides.slice(-this.cloneCount).map((slide) => this.makeClone(slide));
      const after = this.originalSlides.slice(0, this.cloneCount).map((slide) => this.makeClone(slide));
      this.track.prepend(...before);
      this.track.append(...after);
      this.slides = [...this.track.children];
    }

    makeClone(slide) {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-choosz-review-slide');
      clone.removeAttribute('data-shopify-editor-block');
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('role', 'presentation');
      return clone;
    }

    bindEvents() {
      this.track.addEventListener('transitionend', (event) => this.onTransitionEnd(event));
      this.track.addEventListener('transitioncancel', () => this.finishMove());
      this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.viewport.addEventListener('pointerup', (event) => this.onPointerEnd(event));
      this.viewport.addEventListener('pointercancel', (event) => this.onPointerEnd(event, true));
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
      this.root.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event));
      this.onResize = () => {
        window.clearTimeout(this.transitionFallbackTimer);
        this.transitionFallbackTimer = null;
        this.isAnimating = false;
        this.correctLoopPosition();
        this.setPosition(false);
        this.updateViewportHeight();
      };
      this.onVisibilityChange = () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      };
      window.addEventListener('resize', this.onResize);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    stepSize() {
      const slide = this.slides?.[0];
      if (!slide) return 0;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    setPosition(animate) {
      this.track.classList.toggle('is-animating', animate && !this.reducedMotion);
      this.track.style.transform = `translate3d(${-this.index * this.stepSize()}px, 0, 0)`;
    }

    visibleSlideCount() {
      return window.matchMedia('(max-width: 749px)').matches ? 1 : Math.min(3, this.originalSlides.length);
    }

    updateViewportHeight() {
      const visibleSlides = this.slides.slice(this.index, this.index + this.visibleSlideCount());
      const height = Math.max(...visibleSlides.map((slide) => slide.getBoundingClientRect().height), 0);
      if (height > 0) this.viewport.style.height = `${Math.ceil(height)}px`;
    }

    observeSlideHeights() {
      if (!window.ResizeObserver) return;
      this.resizeObserver = new window.ResizeObserver(() => this.updateViewportHeight());
      this.slides.forEach((slide) => this.resizeObserver.observe(slide));
    }

    move(direction, userInitiated = false) {
      if (this.isAnimating) return;
      if (userInitiated) this.restartAutoplay();
      this.index += direction;
      this.isAnimating = !this.reducedMotion;
      this.setPosition(true);
      this.updateViewportHeight();
      if (this.reducedMotion) {
        this.correctLoopPosition();
      } else {
        this.transitionFallbackTimer = window.setTimeout(() => this.finishMove(), 750);
      }
    }

    onTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      this.finishMove();
    }

    finishMove() {
      window.clearTimeout(this.transitionFallbackTimer);
      this.transitionFallbackTimer = null;
      this.isAnimating = false;
      this.correctLoopPosition();
      this.updateViewportHeight();
    }

    correctLoopPosition() {
      if (this.index >= this.originalSlides.length + this.cloneCount) {
        this.index = this.cloneCount;
        this.setPosition(false);
      } else if (this.index <= 0) {
        this.index = this.originalSlides.length;
        this.setPosition(false);
      }
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (this.isAnimating) this.finishMove();
      if (event.pointerType === 'mouse') event.preventDefault();
      this.pointerId = event.pointerId;
      this.pointerStartX = event.clientX;
      this.pointerOffsetX = 0;
      this.isDragging = true;
      this.track.classList.remove('is-animating');
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture?.(event.pointerId);
      this.stopAutoplay();
    }

    onPointerMove(event) {
      if (!this.isDragging || event.pointerId !== this.pointerId) return;
      this.pointerOffsetX = event.clientX - this.pointerStartX;
      if (Math.abs(this.pointerOffsetX) > 4) event.preventDefault();
      const offset = (-this.index * this.stepSize()) + this.pointerOffsetX;
      this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }

    onPointerEnd(event, cancelled = false) {
      if (!this.isDragging || event.pointerId !== this.pointerId) return;
      const distance = cancelled ? 0 : this.pointerOffsetX;
      try {
        if (this.viewport.hasPointerCapture?.(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }
      } catch {}
      this.viewport.classList.remove('is-dragging');
      this.pointerId = null;
      this.pointerStartX = null;
      this.pointerOffsetX = 0;
      this.isDragging = false;

      const threshold = Math.min(80, this.stepSize() * 0.18);
      if (Math.abs(distance) > threshold) {
        this.move(distance < 0 ? 1 : -1, true);
      } else {
        this.isAnimating = !this.reducedMotion;
        this.setPosition(true);
        if (this.reducedMotion) {
          this.isAnimating = false;
        } else {
          this.transitionFallbackTimer = window.setTimeout(() => this.finishMove(), 750);
        }
        this.restartAutoplay();
      }
    }

    onBlockSelect(event) {
      const slide = event.target.closest('[data-choosz-review-slide]');
      if (!slide) return;
      this.stopAutoplay();
      this.index = this.cloneCount + Number(slide.dataset.originalIndex || 0);
      this.setPosition(false);
      this.updateViewportHeight();
    }

    startAutoplay() {
      if (
        !this.autoplayEnabled ||
        document.hidden ||
        this.timer ||
        this.isDragging
      ) return;
      this.timer = window.setInterval(() => this.move(1), this.intervalDuration);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    destroy() {
      this.stopAutoplay();
      window.clearTimeout(this.transitionFallbackTimer);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  }

  const chooszReviewsInstances = new WeakMap();

  const initializeChooszReviews = (scope = document) => {
    scope.querySelectorAll('[data-choosz-reviews]').forEach((root) => {
      if (chooszReviewsInstances.has(root)) return;
      chooszReviewsInstances.set(root, new ChooszReviewsCarousel(root));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeChooszReviews());
  } else {
    initializeChooszReviews();
  }

  document.addEventListener('shopify:section:load', (event) => initializeChooszReviews(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-choosz-reviews]');
    const instance = root ? chooszReviewsInstances.get(root) : null;
    instance?.destroy();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
